var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full mb-0 mt-0 justify-center  bg-gray-800 rounded-lg px-2"},[_c('vue-horizontal',{key:_vm.section,ref:"horizontal",staticClass:"horizontal",attrs:{"button":true,"displacement":0.7}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }